/* TODO: t() */
import React, { Component, Fragment } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import {
  Button,
  ButtonToolbar,
  Checkbox,
  CurrencyInput,
  DummyLogin,
  Form,
  FormField,
  PercentInput,
  RadioGroup,
  RadioItem,
  Separator,
  SubmitButton,
  Text,
  TextInput,
  Picker,
} from '../uiold';
import { themeColors } from '../uiold/Constants';

import IndexedList from '../../support/shared/IndexedList';
import PricingActions from '../../support/PricingActions';
import connectData, { ConnectedProps } from '../../support/connectData';

import PricingMarketItem from './PricingMarketItem';
import SignupFormModel from '../FormBuilder/SignupFormModel';

import { Market } from '../../types/shared/Market';
import { Tier } from '../../types/shared/Tier';
import { OptionValue } from '../../types/FormBuilder/FormElements';

type FormElement = {
  id: string;
  name: string;
};

type SelectedCriteria = {
  id: string;
  value: unknown;
};

type Props = {
  priceTier: Tier;
  formDef: SignupFormModel;
  markets: IndexedList<Market>;
  onDelete: () => void;
  onRevert: () => void;
  onSave: () => void;
  canEdit?: boolean;
};

type State = {
  filteredFields: Array<FormElement>;
  showCriteria: boolean;
  accountCurrency: string;
};

const emptyMarketList: Array<Market> = [];
const emptyMarketIndexedList = new IndexedList(emptyMarketList);
const emptyOptionValueList: Array<OptionValue> = [];

class PriceTier extends Component<FullProps, State> {
  constructor(props: FullProps) {
    super(props);
    this.state = {
      filteredFields: this._getFilteredFields(props.formDef),
      showCriteria: this._getCriteriaField() != null,
      accountCurrency: this._getAccountCurrency(),
    };
  }

  componentDidUpdate(oldProps: FullProps) {
    let newProps = this.props;
    if (oldProps.formDef.fields !== newProps.formDef.fields) {
      this.setState({
        filteredFields: this._getFilteredFields(newProps.formDef),
      });
    }
  }

  render() {
    let { priceTier, canEdit } = this.props;
    return (
      <View style={styles.root}>
        <View style={styles.header}>
          <Text style={styles.headingTwo}>Price Tier Details</Text>
          {priceTier.id !== '0' && canEdit && (
            <Button
              title={t('Delete')}
              onPress={this._delete}
              style={styles.deleteButton}
            />
          )}
        </View>
        <ScrollView style={styles.scrollView}>
          <Form onSubmit={this._save} autoComplete="off">
            <DummyLogin />
            <FormField
              render={(id) => (
                <View style={[styles.formField, styles.textInput]}>
                  <Text accessibilityRole="label" htmlFor={id}>
                    {t('Name')}
                  </Text>
                  <TextInput
                    id={id}
                    disabled={!canEdit}
                    value={priceTier.name}
                    onChangeText={(value) =>
                      this._changeTextValue('name', value)
                    }
                  />
                </View>
              )}
            />
            <View style={[styles.section, { zIndex: 2 }]}>
              {this._renderCriteria()}
            </View>
            <FormField
              render={(id) => (
                <View style={styles.formField}>
                  <Text accessibilityRole="label" htmlFor={id}>
                    {t('Signup/Membership Fee')}
                  </Text>
                  <View style={styles.textInput}>
                    <CurrencyInput
                      disabled={!canEdit}
                      accountCurrency={this.state.accountCurrency}
                      onChange={(value) =>
                        this._changeValue('base_price', value)
                      }
                      defaultValue={priceTier.base_price}
                    />
                  </View>
                </View>
              )}
            />
            <FormField
              render={(id) => (
                <View style={styles.formField}>
                  <Text accessibilityRole="label" htmlFor={id}>
                    {t('Sales Tax/GST')}
                  </Text>
                  <View style={styles.textInput}>
                    <PercentInput
                      disabled={!canEdit}
                      onChange={(value) => this._changeValue('tax_rate', value)}
                      defaultValue={priceTier.tax_rate}
                    />
                  </View>
                </View>
              )}
            />
            <FormField
              render={(_id) => (
                <View style={[styles.formField, styles.inline]}>
                  <Checkbox
                    isDisabled={!canEdit}
                    onChange={() =>
                      this._changeValue(
                        'base_price_is_tax_exempt',
                        !priceTier.base_price_is_tax_exempt,
                      )
                    }
                    isChecked={priceTier.base_price_is_tax_exempt}
                    text="Membership fee is tax exempt"
                  />
                </View>
              )}
            />
            <Separator />
            {this._renderMarketSection()}
            <Separator />
            {canEdit && (
              <ButtonToolbar style={styles.toolbar}>
                <Button title={t('Cancel')} onPress={this._revert} />
                <SubmitButton title={t('Save')} />
              </ButtonToolbar>
            )}
          </Form>
        </ScrollView>
      </View>
    );
  }

  _renderCriteria = () => {
    let { priceTier } = this.props;
    if (priceTier.id === '0') {
      return null;
    }
    return (
      <Fragment>
        <Separator />
        <RadioGroup
          selectedValue={this.state.showCriteria}
          onChange={(value) => this._onShowCriteria(!!value)}
        >
          <View style={styles.formField}>
            <Text style={styles.separatorText}>{t('Apply this pricing:')}</Text>
            <View style={styles.radioGroup}>
              <RadioItem title={t('Never')} value={false} />
              <RadioItem
                title={t('Based on a specific form selection')}
                value={true}
              />
            </View>
            {this._renderFormFieldSelector()}
          </View>
        </RadioGroup>
      </Fragment>
    );
  };

  _renderFormFieldSelector = () => {
    let { priceTier, formDef } = this.props;
    let { showCriteria, filteredFields } = this.state;
    if (!showCriteria) {
      return;
    }
    if (filteredFields.length === 0) {
      return (
        <View style={styles.inline}>
          <Text>{t('No eligible form elements to choose from.')}</Text>
        </View>
      );
    }
    let criteriaField = this._getCriteriaField();
    let criteriaFieldID = criteriaField ? criteriaField.id : null;
    if (criteriaFieldID == null && filteredFields.length) {
      criteriaFieldID = filteredFields[0]?.id ?? '';
      criteriaField = formDef.fields.getByID(criteriaFieldID);
    }
    let selectedField = filteredFields.find(
      (item) => item.id === criteriaFieldID,
    );
    let fieldOptions = criteriaField
      ? criteriaField.getValueAsOptions()
      : emptyOptionValueList;
    let selectedFieldOption = fieldOptions.find(
      (optionValue) => optionValue.id === priceTier.form_field_value,
    );
    if (selectedFieldOption == null && fieldOptions.length) {
      selectedFieldOption = fieldOptions[0];
    }
    return (
      <View style={styles.inline}>
        {t.jsx('When <field></field> is equal to <value></value>', {
          field: () => (
            <Picker
              options={filteredFields}
              selectedItem={selectedField}
              onChange={this._onFormFieldSelect}
            />
          ),
          value: () => (
            <Picker
              options={fieldOptions}
              selectedItem={selectedFieldOption}
              onChange={this._onFormFieldValueSelect}
            />
          ),
          _: (text) => <Text>{text}</Text>,
        })}
      </View>
    );
  };

  _renderMarketSection = () => {
    let { priceTier, canEdit } = this.props;
    // TODO: Normalize in a helper function.
    let isSimplePricing =
      priceTier.simple_pricing == null ? true : priceTier.simple_pricing;
    return (
      <View style={styles.formField}>
        <RadioGroup
          style={styles.radioGroup}
          selectedValue={isSimplePricing}
          onChange={(value) =>
            canEdit && this._changeValue('simple_pricing', !!value)
          }
        >
          <RadioItem title="" value={true} style={styles.noRightPadding} />
          <View style={styles.rightPadding}>
            <Text>{t('Simple pricing')}</Text>
            <Text style={styles.caption}>{t('Same for all markets')}</Text>
          </View>
          <RadioItem title="" value={false} style={styles.noRightPadding} />
          <View style={styles.rightPadding}>
            <Text>{t('Advanced pricing')}</Text>
            <Text style={styles.caption}>{t('Specific for each market')}</Text>
          </View>
        </RadioGroup>
        {isSimplePricing
          ? this._renderSimplePricing()
          : this._renderMarketItems()}
      </View>
    );
  };

  _renderSimplePricing = () => {
    let { priceTier, canEdit } = this.props;

    return (
      <View style={styles.formField}>
        <Text>{t('Price per Market Date')}</Text>
        <View style={styles.textInput}>
          <CurrencyInput
            disabled={!canEdit}
            accountCurrency={this.state.accountCurrency}
            onChange={(value) => this._changeValue('price_per_date', value)}
            defaultValue={priceTier.price_per_date}
          />
        </View>
      </View>
    );
  };

  _renderMarketItems = () => {
    let { markets, priceTier, canEdit } = this.props;
    if (markets == null) {
      markets = emptyMarketIndexedList;
    }
    let items = markets.mapToArray((market) => {
      let marketID = market ? market.id : '';
      return (
        <PricingMarketItem
          disabled={!canEdit}
          accountCurrency={this.state.accountCurrency}
          key={marketID}
          market={market}
          priceTier={priceTier}
        />
      );
    });
    return <View>{items}</View>;
  };

  _getFilteredFields = (formDef: SignupFormModel): Array<FormElement> => {
    // only allow a multi-choice field as the criteria for a tier
    let fields = formDef.fields.filter((field) => {
      let { type } = field.definition;
      return type === 'BooleanElement' || type === 'MultichoiceElement';
    });
    return fields.mapToArray((field) => {
      let { definition } = field;
      let name = typeof definition.name === 'string' ? definition.name : '';
      return {
        id: field.id,
        name,
      };
    });
  };

  _getCriteriaField = (selectedField?: FormElement | null | undefined) => {
    let { priceTier, formDef } = this.props;
    let formFieldID = selectedField
      ? selectedField.id
      : priceTier.form_field_id;
    return formFieldID ? formDef.fields.getByID(formFieldID) : null;
  };

  _onShowCriteria = (showCriteria: boolean) => {
    let { priceTier } = this.props;
    this.setState({ showCriteria });
    if (showCriteria) {
      let { id, value } = this._getSelectedCriteriaField();
      PricingActions.updateTier(priceTier, {
        form_field_id: id,
        form_field_value: value,
      });
    } else {
      PricingActions.updateTier(priceTier, {
        form_field_id: null,
        form_field_value: null,
      });
    }
  };

  _onFormFieldSelect = (selectedItem: FormElement) => {
    let { priceTier } = this.props;
    let { id, value } = this._getSelectedCriteriaField(selectedItem);
    PricingActions.updateTier(priceTier, {
      form_field_id: id,
      form_field_value: value,
    });
  };

  _onFormFieldValueSelect = (selectedItem: OptionValue) => {
    let { priceTier } = this.props;
    let { id, value } = this._getSelectedCriteriaField(null, selectedItem);
    PricingActions.updateTier(priceTier, {
      form_field_id: id,
      form_field_value: value,
    });
  };

  _getSelectedCriteriaField = (
    selectedField?: FormElement | null | undefined,
    selectedOption?: OptionValue | null | undefined,
  ): SelectedCriteria => {
    let { priceTier, formDef } = this.props;
    let { filteredFields } = this.state;
    let criteriaField = this._getCriteriaField(selectedField);
    if (criteriaField == null && filteredFields.length) {
      criteriaField = formDef.fields.getByID(filteredFields[0]?.id ?? '');
    }
    if (criteriaField == null) {
      return { id: '', value: null };
    }
    let fieldOptions = criteriaField.getValueAsOptions();
    let searchValue = selectedOption
      ? selectedOption.id
      : priceTier.form_field_value;
    let selectedFieldOption =
      fieldOptions.find((option) => option.id === String(searchValue)) ||
      fieldOptions[0];
    return {
      id: criteriaField.id,
      value: selectedFieldOption ? selectedFieldOption.id : null,
    };
  };

  _changeValue = (name: string, value: number | boolean) => {
    let { priceTier } = this.props;
    let updates = { [name]: value };
    PricingActions.updateTier(priceTier, updates);
  };

  _changeTextValue = (name: string, value: string) => {
    let { priceTier } = this.props;
    let updates = { [name]: value };
    PricingActions.updateTier(priceTier, updates);
  };

  _delete = () => {
    this.props.onDelete();
  };

  _revert = () => {
    this.props.onRevert();
  };

  _save = () => {
    this.props.onSave();
  };

  _getAccountCurrency = () => {
    let { account } = this.props;
    return (account && account.settings && account.settings.currency) || 'USD';
  };
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: 5,
    borderColor: themeColors.withOpacity.blue50,
    backgroundColor: themeColors.white,
  },
  header: {
    paddingVertical: 20,
    marginHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: themeColors.withOpacity.blue50,
  },
  scrollView: {
    paddingHorizontal: 20,
  },
  deleteButton: {
    borderColor: themeColors.red,
  },
  headingTwo: {
    fontSize: 16,
    lineHeight: 22,
    color: themeColors.headingText,
    fontWeight: '600',
    paddingVertical: 6,
  },
  inline: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  formField: {
    marginVertical: 10,
    padding: 5,
  },
  separatorText: {
    paddingVertical: 5,
  },
  radioGroup: {
    flexDirection: 'row',
    paddingVertical: 5,
  },
  toolbar: {
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingVertical: 10,
  },
  textInput: {
    width: 230,
  },
  caption: {
    fontSize: 12,
    color: themeColors.blue,
  },
  noRightPadding: {
    paddingRight: 0,
  },
  rightPadding: {
    paddingRight: 15,
  },
  section: {},
});

const connector = connectData<Props>()(() => ({
  account: { dataStoreKey: 'account' },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(PriceTier);
